module.exports = __webpack_public_path__ + "bin/de23b7d9a7af0b0a35e64ba4333f5348.svg";